export default {
  reviews: {
    id: 'product_reviews_top',
    defaultMessage: `{ count, plural,
      one {# review}
      other {# reviews}
    }`,
  },
  ariaLabelReviews: {
    id: 'product_reviews_top_aria_label',
    defaultMessage: `Based on { count, plural,
      one {# review}
      other {# reviews}
    }, read all reviews`,
  },
}
